module.exports = __webpack_public_path__ + "media/images/flt-health-system-partners-6366247686bc542a6c03feffa811cb3a.png";